/**
 * WorkspaceCanvas
 * 
 * The main workspace area with:
 * - Tab bar for open artifacts
 * - Artifact viewer/editor
 * - Empty state with quick actions
 * - Citation panel (slides in from right when viewing a citation)
 */

import React from 'react';
import { useWorkspace } from '../artifacts';
import { ArtifactTabs } from './ArtifactTabs';
import { ArtifactViewer } from './ArtifactViewer';
import { EmptyWorkspace } from './EmptyWorkspace';
import { CitationPanel } from './CitationPanel';

interface WorkspaceCanvasProps {
  className?: string;
}

export const WorkspaceCanvas: React.FC<WorkspaceCanvasProps> = ({ className = '' }) => {
  const { openArtifacts, activeArtifact, openCitation, setOpenCitation } = useWorkspace();

  const hasOpenArtifacts = openArtifacts.length > 0;

  return (
    <div className={`flex flex-col h-full w-full bg-white ${className}`}>
      {/* Tab bar - only show if there are open artifacts */}
      {hasOpenArtifacts && (
        <ArtifactTabs />
      )}

      {/* Content area */}
      <div className="flex-1 min-h-0 overflow-hidden flex">
        {/* Main content fills available canvas; individual editors handle their own centering */}
        <div className="flex-1 min-w-0">
          {activeArtifact ? (
            <ArtifactViewer artifact={activeArtifact} />
          ) : (
            <EmptyWorkspace />
          )}
        </div>

        {/* Citation panel - slides in from the right of the canvas (left of chat) */}
        <CitationPanel 
          citation={openCitation} 
          onClose={() => setOpenCitation(null)} 
        />
      </div>
    </div>
  );
};

export default WorkspaceCanvas;

